import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

export enum PasswordConfigActionTypes {
  GET_PASSWORD_STRATEGY = 'PASSWORD_CONFIG.GET_PASSWORD_STRATEGY',
  GET_PASSWORD_STRATEGY_SUCCESS = 'PASSWORD_CONFIG.GET_PASSWORD_STRATEGY_SUCCESS',
  GET_PASSWORD_STRATEGY_FAIL = 'PASSWORD_CONFIG.GET_PASSWORD_STRATEGY_FAIL',

  SET_PASSWORD_STRATEGY = 'PASSWORD_CONFIG.SET_PASSWORD_STRATEGY',
  SET_PASSWORD_STRATEGY_SUCCESS = 'PASSWORD_CONFIG.SET_PASSWORD_STRATEGY_SUCCESS',
  SET_PASSWORD_STRATEGY_FAIL = 'PASSWORD_CONFIG.SET_PASSWORD_STRATEGY_FAIL',
}

export interface IGetPasswordStrategyAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.GET_PASSWORD_STRATEGY;
}

export interface IGetPasswordStrategySuccessAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_SUCCESS;
  passwordStrategy: IPasswordStrategy;
}

export interface IGetPasswordStrategyFailAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_FAIL;
  error: TAppError;
}

export interface ISetPasswordStrategyAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.SET_PASSWORD_STRATEGY;
}

export interface ISetPasswordStrategySuccessAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_SUCCESS;
  passwordStrategy: IPasswordStrategy;
}

export interface ISetPasswordStrategyFailAction extends IBaseAction {
  type: typeof PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_FAIL;
  error: TAppError;
}
export type TPasswordStrategyAction =
  | IGetPasswordStrategyAction
  | IGetPasswordStrategySuccessAction
  | IGetPasswordStrategyFailAction
  | ISetPasswordStrategyAction
  | ISetPasswordStrategySuccessAction
  | ISetPasswordStrategyFailAction;

export interface IPasswordStrategyState extends IBaseState {
  passwordStrategy: IPasswordStrategy;
}

export interface IPasswordStrategy {
  passwordChangeRedirectUrl: string;
  passwordPattern?: {
    minLength: number;
    /* eslint-disable @typescript-eslint/naming-convention */
    requireLetters: boolean;
    requireCaseDiff: boolean;
    requireNumbers: boolean;
    requireSpecialCharacter: boolean;
    /* eslint-enable @typescript-eslint/naming-convention */
  };
}

export interface IStrategyPasswordForm {
  requireLetters?: number;
  requireCaseDiff?: number;
  requireNumbers?: number;
  requireSpecialCharacter?: number;
  minLength?: number;
}
